import {ReferralTypeEnum, ShareActivityLinkAnalytics} from '../../../../shared/entity_datas/EntityDatas'
import {DiscordInstance} from '../discord/DiscordInstance'
import {SDKRequest} from '../../../../shared/DiscordActivityTypes'
import {clientI18n} from '../../../shared/scripts/ClientI18n'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {setElementInnerHTML, createParagraphIn, createDivIn, createImgIn, createHeaderIn} from '../../../shared/scripts/ui_utils/DomUtils'
import {ReferralProgram, ReferralReward} from '../../../../shared/ReferralProgram'
import {navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils'

export class ViewPopupRewardsProgram extends ViewPopup {
    constructor() {
        const inviteFriendsButtonAction = () => {
            DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.ShareActivityLink, {
                message: clientI18n.t('strings:homePage.popups.discordShareActivity.text'),
                referralTypeId: ReferralTypeEnum.ShareActivityReferralProgramReturnToHomeAfterGameEndPopup.toString(),
                analyticsPopupTriggered: ShareActivityLinkAnalytics.ReturnToHomeAfterGameEndReferralProgramPopupTriggered,
                analyticsPopupSuccess: ShareActivityLinkAnalytics.ReturnToHomeAfterGameEndReferralProgramSuccessfullyShared,
            })

            navigateToPage('/store#referrals')
        }

        super({key: 'strings:homePage.popups.rewardsProgram.title'},
            {key: 'strings:colonistCommon.utils.emptyString'},
            inviteFriendsButtonAction,
            () => undefined, true,
            {
                showXButton: false,
                showCheckButton: true,
                showXonHeader: true,
            })

        this.body.style.flexDirection = 'column'

        setElementInnerHTML(this.body, {key: 'strings:colonistCommon.utils.emptyString'})
        createParagraphIn(this.body, {key: 'strings:homePage.popups.rewardsProgram.body'}, 'popup-membership-body')

        const imageWrapper = createDivIn(this.body, 'popup-subscription-in-room-items-wrapper', '')
        const referralProgram = ReferralProgram.referralRewardLevels
        referralProgram.forEach((referralReward: ReferralReward) => {
            const imageCard = createDivIn(imageWrapper, 'popup-subscription-in-room-item-img', '')
            createImgIn(imageCard, referralReward.image)
            createHeaderIn(imageCard, referralReward.name, '')
            createParagraphIn(imageCard, {key: 'strings:homePage.popups.rewardsProgram.description', options: {count: referralReward.referralCount}}, '')
            imageWrapper.appendChild(imageCard)
        })

        this.changeCheckButtonText({key: 'strings:homePage.popups.rewardsProgram.button'})
        this.show()
    }
}
